import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppShell from "@/components/AppShell";
import Access from "@/pages/Access";
import Support from "@/pages/Support";
import History from "@/pages/History";
import Deploy from "@/pages/Deploy";
import Technicians from "@/pages/Technicians";
import Billing from "@/pages/Billing";
import Admin from "@/pages/Admin";
import Security from "@/pages/Security";
import LogoChoice from "@/pages/LogoChoice";
import DemoVideo from "@/pages/DemoVideo";
import TemplatePreview from "@/pages/TemplatePreview";
import { ModuleGate } from "@/components/ModuleGate";
import { MaintenanceGate } from "@/components/MaintenanceGate";
import Join from "@/pages/Join";
import PaymentResult from "@/pages/PaymentResult";
import Session from "@/pages/Session";
import SuperAdmin from "@/pages/SuperAdmin";
import Rmm from "@/pages/Rmm";
import RmmMachine from "@/pages/RmmMachine";

const Protected = ({ children, admin, superadmin }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen grid place-items-center text-slate-400 font-mono text-xs" data-testid="auth-loading">
        CHARGEMENT…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/app" replace />;
  if (superadmin && !user.superadmin) return <Navigate to="/app" replace />;
  return children;
};

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<MaintenanceGate><Landing /></MaintenanceGate>} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<MaintenanceGate><Register /></MaintenanceGate>} />
            <Route path="/join" element={<Join />} />
            <Route path="/logos" element={<LogoChoice />} />
            <Route path="/video-demo" element={<DemoVideo />} />
            <Route path="/apercus" element={<TemplatePreview />} />
            <Route path="/join/:code" element={<Join />} />
            <Route path="/payment/success" element={<Protected><PaymentResult success /></Protected>} />
            <Route path="/payment/cancel" element={<Protected><PaymentResult /></Protected>} />
            <Route path="/session/:id" element={<Protected><Session /></Protected>} />
            <Route path="/app" element={<Protected><AppShell /></Protected>}>
              <Route index element={<Access />} />
              <Route path="support" element={<Support />} />
              <Route path="history" element={<History />} />
              <Route path="rmm" element={<ModuleGate module="rmm"><Rmm /></ModuleGate>} />
              <Route path="rmm/:id" element={<ModuleGate module="rmm"><RmmMachine /></ModuleGate>} />
              <Route path="agents" element={<Deploy />} />
              <Route path="technicians" element={<Protected admin><Technicians /></Protected>} />
              <Route path="billing" element={<Protected admin><Billing /></Protected>} />
              <Route path="admin" element={<Protected admin><Admin /></Protected>} />
              <Route path="security" element={<Security />} />
              <Route path="superadmin" element={<Protected superadmin><SuperAdmin /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
